import ReportStatisticCard from "@/admin/insights/member-reports/common/MemberReportStatisticCard"
import { MemberReportSurveysCompletedStatisticsCardFragment$key } from "@/admin/insights/member-reports/tabs/contents/__generated__/MemberReportSurveysCompletedStatisticsCardFragment.graphql"
import { useLabels } from "@/core/context/LabelsContext"
import { graphql, useFragment } from "react-relay"

interface Props {
  organizationMembershipKey: MemberReportSurveysCompletedStatisticsCardFragment$key
}

export default function MemberReportSurveysCompletedStatisticsCard({
  organizationMembershipKey,
}: Props) {
  const labels = useLabels()
  const organizationMembership =
    useFragment<MemberReportSurveysCompletedStatisticsCardFragment$key>(
      graphql`
        fragment MemberReportSurveysCompletedStatisticsCardFragment on OrganizationMembership
        @argumentDefinitions(startDate: { type: "String" }) {
          surveysCompletedReport(startDate: $startDate) {
            totalCompleted
            totalAvailable
          }
        }
      `,
      organizationMembershipKey
    )

  return (
    <ReportStatisticCard
      testid={"MemberReportSurveysCompletedStatisticCard"}
      value={
        organizationMembership.surveysCompletedReport.totalAvailable
          ? `${organizationMembership.surveysCompletedReport.totalCompleted}/${organizationMembership.surveysCompletedReport.totalAvailable}`
          : "-"
      }
      subtitle={`Total Surveys Completed`}
      tooltip={`The number of surveys this ${labels.admin_member.singular} has completed compared to the total surveys available to them.`}
    />
  )
}
